import { GridFields } from 'components';
import { useFormContext } from 'libs/form/useFormContext';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { Section } from 'modules/client/common/components';

export const USTaxResidencySection = () => {
  const { t } = useTranslation();
  const { readOnly } = useFormContext();

  return (
    <Section
      datax="USTaxResidency"
      title={t('client.client.USTaxResidency.title')}
    >
      <GridFields>
        <Input
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t('client.client.USTaxResidency.field.label')}
          value={t('common.no')}
        />
      </GridFields>
    </Section>
  );
};
